module.exports = __webpack_public_path__ + "static/media/lafise-star-icon.8f9995f6.svg";